var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.83333C2.5 0.803193 3.36172 0 4.38462 0L11.6154 0C12.6383 0 13.5 0.803193 13.5 1.83333V14.1667C13.5 15.1968 12.6383 16 11.6154 16H4.38462C3.36172 16 2.5 15.1968 2.5 14.1667V1.83333ZM4.38462 1C3.8781 1 3.5 1.39071 3.5 1.83333V14.1667C3.5 14.6093 3.8781 15 4.38462 15H11.6154C12.1219 15 12.5 14.6093 12.5 14.1667V1.83333C12.5 1.39071 12.1219 1 11.6154 1H4.38462Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 13.25C8.75 13.6642 8.41421 14 8 14C7.58579 14 7.25 13.6642 7.25 13.25C7.25 12.8358 7.58579 12.5 8 12.5C8.41421 12.5 8.75 12.8358 8.75 13.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3C5.5 2.72386 5.72386 2.5 6 2.5H10C10.2761 2.5 10.5 2.72386 10.5 3C10.5 3.27614 10.2761 3.5 10 3.5H6C5.72386 3.5 5.5 3.27614 5.5 3Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bf7c45abd4acb2477c29ba1fd62e85f0.svg";
export { ForwardRef as ReactComponent };